import { render } from "./EmpresasExport.vue?vue&type=template&id=d4ef0cea"
import script from "./EmpresasExport.vue?vue&type=script&lang=js"
export * from "./EmpresasExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__